import { render, staticRenderFns } from "./viewHelpDesk.vue?vue&type=template&id=71d81cf2"
import script from "./viewHelpDesk.vue?vue&type=script&lang=js"
export * from "./viewHelpDesk.vue?vue&type=script&lang=js"
import style0 from "./viewHelpDesk.vue?vue&type=style&index=0&id=71d81cf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports